<app-header></app-header>

<div id="app" style="margin: 0 8px!important;">
  <router-outlet></router-outlet>
</div>
